"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingGoModVersionDirectiveError = exports.InvalidUserInputError = void 0;
var invalid_user_input_error_1 = require("./invalid-user-input-error");
Object.defineProperty(exports, "InvalidUserInputError", { enumerable: true, get: function () { return invalid_user_input_error_1.InvalidUserInputError; } });
var missing_go_mod_version_directive_error_1 = require("./missing-go-mod-version-directive-error");
Object.defineProperty(exports, "MissingGoModVersionDirectiveError", { enumerable: true, get: function () { return missing_go_mod_version_directive_error_1.MissingGoModVersionDirectiveError; } });
// Other common parser error types:
// OutOfSyncError - not applicable yet, since for dep/vendor, the manifests do not contain the names of actual
// modules/packages used, so they cannot be out of sync with the lockfiles.
//# sourceMappingURL=index.js.map